import React from 'react';
export function NewDeviceTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-459">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-460">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-461" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-462">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-463">
          New sign-in from unrecognized device
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-464">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-465">
          We detected a new sign-in to your Aisco Workspace account from a
          device or location we don't recognize.
        </p>

        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-466">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-467">
            Sign-in Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '8px'
        }} data-id="element-468">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-469">
              <span style={{
              color: '#6b7280'
            }} data-id="element-470">
                Device:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-471">
                Chrome on macOS
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-472">
              <span style={{
              color: '#6b7280'
            }} data-id="element-473">
                Location:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-474">
                Madrid, Spain
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-475">
              <span style={{
              color: '#6b7280'
            }} data-id="element-476">
                Time:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-477">
                January 15, 2025 at 10:30 AM
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-478">
              <span style={{
              color: '#6b7280'
            }} data-id="element-479">
                IP Address:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-480">
                192.168.1.1
              </span>
            </div>
          </div>
        </div>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-481">
          <p style={{
          margin: '0',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-482">
            <strong data-id="element-483">Was this you?</strong> If you recognize this activity, you
            can safely ignore this message. Consider marking this device as
            trusted for future sign-ins.
          </p>
        </div>

        <div style={{
        backgroundColor: '#fef3c7',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginBottom: '32px'
      }} data-id="element-484">
          <p style={{
          margin: '0',
          color: '#92400e',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-485">
            <strong data-id="element-486">Wasn't you?</strong> If you don't recognize this activity,
            secure your account immediately by changing your password and
            reviewing recent activity.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-487">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-488">
            Review account activity
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-489">
          Need help? Contact{' '}
          <a href="mailto:support@aisco.com" style={{
          color: '#2563eb',
          textDecoration: 'none'
        }} data-id="element-490">
            support@aisco.com
          </a>
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-491">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-492">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-493" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}